import { FinancialManagementRouteMap } from '@/new-router/financial-management'

const userInfo = () => import('@/views/Statistics/userInfo')
const capacity = () => import('@/views/Statistics/capacity')
const recharge = () => import('@/views/Statistics/recharge')
const balance = () => import('@/views/Statistics/balance')
const performance = () => import('@/views/Statistics/performance')
const Home = () => import('@/views/Home/home')
const incomeVerification = () => import('@/views/Statistics/incomeVerification')

export default {
  path: '/statistics',
  name: 'statistics',
  component: Home,
  meta: {
    title: '财务报表',
    icon: 'icon-administrator',
    showSubiems: false,
    sort: 13,
    modules: 'statistics',
    permission: 'statistics:root',
  },
  children: [
    {
      path: 'userInfo',
      name: 'statisticsUserInfo',
      component: userInfo,
      meta: {
        title: '用户信息',
        active: ['statisticsUserInfo'],
        permission: 'statistics:user',
        belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialStatistics],
      },
    },
    {
      path: 'capacity',
      name: 'statisticsCapacity',
      component: capacity,
      meta: {
        title: '计算量',
        active: ['statisticsCapacity'],
        permission: 'statistics:calculation',
        belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialStatistics],
      },
    },
    {
      path: 'fundsDetails',
      name: 'statisticsRecharge',
      component: recharge,
      meta: {
        title: '充值',
        active: ['statisticsRecharge'],
        permission: 'statistics:recharge',
        belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialStatistics],
      },
    },
    {
      path: 'balance',
      name: 'statisticsBalance',
      component: balance,
      meta: {
        title: '余额',
        active: ['statisticsBalance'],
        permission: 'statistics:balance',
        belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialStatistics],
      },
    },
    {
      path: 'performance',
      name: 'statisticsPerformance',
      component: performance,
      meta: {
        title: '业绩申报',
        active: ['statisticsPerformance'],
        permission: 'finance:achievement',
        belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialStatistics],
      },
    },
    {
      path: 'incomeVerification',
      name: 'statisticsIncomeVerification',
      component: incomeVerification,
      meta: {
        title: '用户对账单',
        active: ['statisticsIncomeVerification'],
        permission: 'statistics:income:verification',
        belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialStatistics],
      },
    },
  ],
}
